module.exports = __webpack_public_path__ + "img/mobileSpecifications-Img-Vacuum-40-min-1.0591186c.c0a85db8.png";